export const fetchPartnerSummaryCSVData = async (url: string): Promise<string> =>
    fetch(url).then(res => {
        if (res.status >= 400) {
            return Promise.reject(res.json());
        }
        return Promise.resolve(res.text());
    });

export default fetchPartnerSummaryCSVData;
